export const authHeader = (userToken: string) => ({
  Authorization: `Bearer ${userToken}`,
});

export const jsonAuthHeaders = (userToken: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
});
